import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=0d069939&scoped=true"
import script from "./CustomersView.vue?vue&type=script&lang=js"
export * from "./CustomersView.vue?vue&type=script&lang=js"
import style0 from "./CustomersView.vue?vue&type=style&index=0&id=0d069939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d069939",
  null
  
)

export default component.exports